import React, { useContext } from 'react'
import { Row, Col, Carousel } from 'react-bootstrap'
import styled from 'styled-components'
import { importAll } from 'utils/image'
import { navigate } from 'raviger'
import { I18nContext } from 'i18n'

const HomeImage = () => {
  const { translate } = useContext(I18nContext)
  const images = importAll(
    require.context('images/carousel', false, /\.(png|jpe?g|svg|webp)$/)
  )
  return (
    <Content>
      <Col className="p-0">
        <Carousel interval={8000}>
          {images.map((image, ix) => (
            <Carousel.Item key={`slide-${ix}`}>
              <img className="d-block w-100" src={image} alt="slide" />
            </Carousel.Item>
          ))}
        </Carousel>
      </Col>
      <Col md={4} className="p-3">
        <div className="p-4">
          <div className="pt-4">WELCOME TO THE</div>
          <h3>NSPA EXCHANGE MEMBER SITE</h3>
          <p className="mt-4">An exclusive benefit for NSPA Members</p>
          <Button onClick={() => navigate('/search/advanced/programs')}>
            {translate('landing_button_search_text')}
          </Button>
        </div>
      </Col>
    </Content>
  )
}

const Content = styled(Row)`
  background-color: ${({ theme }) => theme.palette.primary[0]};
  color: ${({ theme }) => theme.palette.grayscale[8]};
  max-height: 400px;

  img {
    height: 400px;
    object-fit: cover;
    object-position: center;
  }
`

const Button = styled.button`
  width: 79%;
  border: 0;
  height: 4rem;
  background-color: ${({ theme }) => theme.palette.secondary[0]};
  position: absolute;
  bottom: 3rem;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.9rem;
  text-transform: uppercase;
  padding: 0 0.75rem;
`

export default HomeImage
